import React from 'react';

const Location = () => {
   return(
       <div id="location" className="py-3">
          {/* <div className="container px-5 py-10 mx-auto flex sm:flex-nowrap flex-wrap">
                <div className="lg:w-2/3 md:w-1/2 bg-gray-900 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
                    <iframe
                    width="100%"
                    height="100%"
                    title="map"
                    className="absolute inset-0"
                    frameBorder={0}
                    marginHeight={0}
                    marginWidth={0}
                    style={{ filter: "opacity(0.7)" }}
                    src="https://www.google.com/maps/embed/v1/directions?origin=pekalongan+wonokerto+kulon&destination=lombok+timur+suralaga&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
                    />
                </div>
                <form
                    netlify
                    name="contact"
                    className="lg:w-1/3 md:w-1/2 flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0">
                    <h2 className="text-white sm:text-4xl text-3xl mb-1 font-medium title-font">
                        Hire Me
                    </h2>
                    <p className="leading-relaxed mb-5">
                        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Illum
                        suscipit officia aspernatur veritatis. Asperiores, aliquid?
                    </p>
                    <div className="relative mb-4">
                    <label htmlFor="name" className="leading-7 text-sm text-gray-400">
                        Name
                    </label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    />
                    </div>
                    <div className="relative mb-4">
                    <label htmlFor="email" className="leading-7 text-sm text-gray-400">
                        Email
                    </label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 text-base outline-none text-gray-100 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    />
                    </div>
                    <div className="relative mb-4">
                    <label
                        htmlFor="message"
                        className="leading-7 text-sm text-gray-400">
                        Message
                    </label>
                    <textarea
                        id="message"
                        name="message"
                        className="w-full bg-gray-800 rounded border border-gray-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-900 h-32 text-base outline-none text-gray-100 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
                    />
                    </div>
                    <button
                    type="submit"
                    className="text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">
                        Submit
                    </button>
                </form>
            </div> */}
            <div className="container mx-auto">

                <div className="relative rounded-lg flex flex-col md:flex-row items-center md:shadow-xl md:h-72 mx-2">
                    
                    <div className="z-0 order-1 md:order-2 md:-ml-7 relative w-full md:w-4/5 h-80 md:h-full overflow-hidden rounded-lg md:rounded-none md:rounded-r-lg">
                        {/* <div className="bg-floral absolute inset-0 w-full h-full object-fill object-center bg-blue-400 bg-opacity-30 bg-cover bg-bottom" ></div>
                        <div className="md:hidden absolute inset-0 h-full p-6 pb-6 flex flex-col-reverse justify-start items-start bg-gradient-to-b from-transparent via-transparent to-gray-900">
                            <h3 className="w-full font-bold text-2xl text-white leading-tight mb-2">HOTEL AMANEE</h3>
                            <h4 className="w-full text-xl text-gray-100 leading-tight">Bienvenido a</h4>
                        </div>
                        <svg className="hidden md:block absolute inset-y-0 h-full w-24 fill-current text-white -ml-12" viewBox="0 0 100 100" preserveAspectRatio="none">
                            <polygon points="50,0 100,0 50,100 0,100" />
                        </svg> */}
                        <div className="absolute inset-0 w-full h-full object-fill object-center bg-blue-400 bg-opacity-30 bg-cover bg-bottom">
                            <iframe
                            width="100%"
                            height="100%"
                            title="map"
                            className=""
                            frameBorder={0}
                            marginHeight={0}
                            marginWidth={0}
                            style={{ filter: "opacity(0.7)" }}
                            src="https://www.google.com/maps/embed/v1/directions?origin=pekalongan+wonokerto+kulon&destination=lombok+timur+suralaga&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
                            />
                        </div>
                        <div className="md:hidden absolute h-full p-6 pb-6 flex flex-col-reverse justify-start items-start bg-gradient-to-b from-transparent via-transparent to-gray-900">
                            <h3 className="w-full font-poppins text-2xl text-white leading-tight mb-2">Lombok timur</h3>
                        </div>
                    </div>

                    <div className="z-10 order-2 md:order-1 w-full h-full md:w-4/5 flex items-center -mt-6 md:mt-0">
                        <div className="p-8 md:pr-18 md:pl-10 md:py-8 font-poppins mx-2 md:mx-0 h-full bg-gray-wed rounded-lg md:rounded-none md:rounded-l-lg shadow-xl md:shadow-none">
                            <h4 className="md:block text-md text-white">Yang insyaallah akan di selenggarakan pada :</h4>
                            {/* <h3 className="hidden md:block font-bold text-2xl text-gray-700">HOTEL AMANEE</h3> */}
                            <div className="grid grid-cols-3 gap-4 my-3">
                                <div className="text-white border-r-2 pl-2">
                                    <div className="font-Alexs text-2xl font-bold">
                                        Akad
                                    </div>
                                    <div className="text-sm">
                                        Pukul 09.00 WIT
                                    </div>
                                </div>
                                <div className="text-white border-r-2">
                                    <div className="font-Alexs text-2xl font-bold">
                                        Minggu
                                    </div>
                                    <div className="text-sm">
                                        14 November 2021
                                    </div>
                                </div>
                                <div className="text-white">
                                    <div className="font-Alexs text-2xl font-bold">
                                        Resepsi
                                    </div>
                                    <div className="text-sm">
                                        Pukul 09.30 WIT - Selesai
                                    </div>
                                </div>
                            {/* <p className="text-white">Resepsi Pernikahan :</p>
                            <p className="text-white">09.00 - 11.00</p> */}
                            </div>
                            <p className="text-white text-sm text-justify">Timba Ekek Desa Suralaga Barat indomaret, Jalan Dusun, Suralaga <br/>KAB.LOMBOK TIMUR - SURALAGA, NUSA TENGGARA BARAT (NTB)</p>
                            <a className="flex items-baseline mt-3 text-white hover:text-blue-900 focus:text-blue-900" href="/">
                                <span onClick={() => window.open("https://www.google.com/maps/place/Timba+Ekek/@-8.4659611,116.257712,9.67z/data=!4m5!3m4!1s0x2dcc49b56bc3c0bf:0xf803b27f3077dacc!8m2!3d-8.5971422!4d116.5230392", "_blank")}>Lokasi Map</span>
                                <span className="text-xs ml-1">&#x279c;</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
      </div>
   );
}

export default Location;